@if (isPaid) {
  <span class="status-text" [class.hide-mobile]="shortenOnMobile">Betaald</span>
  <app-icon class="status-icon text-active" icon="circle-check"/>
} @else {
  <span class="status-text" [class.hide-mobile]="shortenOnMobile">Niet betaald</span>
  <app-icon class="status-icon text-warning" icon="exclamation-circle"/>
}
